import React from "react";
import { SkeletonStatValue } from "../components/Skeleton";

export const Card = ({ title, action, children, ...rest }) => (
  <section className="fw-card" {...rest}>
    {(title || action) && (
      <div className="fw-card__head">
        {title && <h3 className="fw-card__title">{title}</h3>}
        {action}
      </div>
    )}
    {children}
  </section>
);

export const StageChip = ({ status }) => (
  <span className="fw-chip" data-variant={status}>{(status || "pending").replace(/_/g, " ")}</span>
);

export const Stat = ({ label, value, loading = false }) => (
  <div className="fw-stat">
    <span className="fw-stat__label">{label}</span>
    <span className="fw-stat__value">
      {loading ? <SkeletonStatValue /> : value}
    </span>
  </div>
);

export const Empty = ({ children }) => <div className="fw-empty">{children}</div>;

export const Field = ({ label, children }) => (
  <div className="fw-field">
    <label>{label}</label>
    {children}
  </div>
);
